var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "comp-info" }, [
    _c("div", { staticClass: "comp-info-wrap" }, [
      _c("div", { staticClass: "comp-info-left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "info-detail" }, [
          _c("div", { staticClass: "info-detail-top" }, [
            _c("h4", [
              _vm._v(_vm._s(_vm._f("stringHide")(_vm.info.userMobile)))
            ]),
            _vm._v(" "),
            Boolean(_vm.info.vipLevel)
              ? _c("div", {
                  staticClass: "info-detail-level",
                  class: "bg-" + _vm.info.vipLevel
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "info-detail-bottom" },
            [
              _c("span", [_vm._v("总可用积分：")]),
              _vm._v(" "),
              Boolean(_vm.info.integral)
                ? [
                    _c("span", [_vm._v(_vm._s(_vm.info.integral))]),
                    _vm._v(" "),
                    _c("i")
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "comp-info-right",
          on: {
            click: function($event) {
              return _vm.$emit("out")
            }
          }
        },
        [_vm._v("退出")]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info-img" }, [
      _c("img", {
        attrs: { src: require("@/assets/images/user/head.png"), alt: "" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-19a131a1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-19a131a1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/compInfo.vue
// module id = null
// module chunks = 